import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, inView = true }) => {
  const ref = useRef(null);
  const visible = useInView(ref, { once: true, margin: "-40px" });
  return (
    <span ref={ref} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={visible || !inView ? { y: "0%" } : {}}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const Chapter = ({ number, label, dark = false }) => (
  <Reveal className="flex items-baseline gap-4 mb-10 sm:mb-14">
    <span className="font-serif text-sm text-gold tracking-[0.2em]">{number}</span>
    <span className="gold-rule w-12" aria-hidden="true" />
    <span
      className={`text-[11px] sm:text-xs uppercase tracking-[0.3em] ${
        dark ? "text-taupe" : "text-taupe"
      }`}
    >
      {label}
    </span>
  </Reveal>
);
